// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .add-engagement .p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container, .add-engagement .p-autocomplete{
    padding-left: 0;
    text-indent: 7px;
}

.w-100 {
    font-size: small;
    color: #646262;
}

.cancel:hover {
    background-color:#666 !important;
  }

  ::ng-deep .add-engagement .radiobtn label {
    position: relative;
    bottom: 0;
  }

  .hinttext1{
    font-size: 10px;
    color: #333;
    line-height: 0px;
    left: 5px;
    position: relative;
    bottom: 0;
  }

  .row {
    display: flex;
  }
  
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
